var exports = {
  "x": "x61f99309--ec63b3--button",
};

module.exports = exports;
